import { render, staticRenderFns } from "./CreateCustomerModal.vue?vue&type=template&id=0e2c405b&scoped=true&"
import script from "./CreateCustomerModal.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2c405b",
  null
  
)

export default component.exports